module.exports = __webpack_public_path__ + "static/media/порог школы стенгазета.7a1591df.jpg";